// Copyright (c) 2012-2021 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved. NOTICE: All information contained herein
// is, and remains the property of GRAB. The intellectual and technical concepts contained herein are confidential, proprietary
// and controlled by GRAB and may be covered by patents, patents in process, and are protected by trade secret or copyright law.
//
// You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate, adapt or change this material
// in any way unless prior written permission is obtained from GRAB. Access to the source code contained herein is hereby
// forbidden to anyone except current GRAB employees or contractors with binding Confidentiality and Non-disclosure agreements
// explicitly covering such access.
//
// The copyright notice above does not evidence any actual or intended publication or disclosure of this source code,
// which includes information that is confidential and/or proprietary, and is a trade secret, of GRAB.
//
// ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE
// CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND
// INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY
// OR IMPLY ANY RIGHTS TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING
// THAT IT MAY DESCRIBE, IN WHOLE OR IN PART.

import React from 'react'
import { Modal, Input, Form, Select, message } from 'antd'

class EditUserModal extends React.Component {
  formRef = React.createRef()

  componentWillReceiveProps (nextProps) {
    if (nextProps.user !== this.props.user) {
      this.formRef.current.setFieldsValue({
        ...nextProps.user
      })
    }
  }

  handleRoleChange = v => {
    this.formRef.current.setFieldsValue({
      role_ids: v
    })
  }

  handleEmailChange = e => {
    this.formRef.current.setFieldsValue({
      email: e.target.value
    })
  }

  handleSubmit = () => {
    this.formRef.current
      .validateFields()
      .then(values => {
        this.props.onOk(values)
      })
      .catch(err => {
        console.log(err)
      })
  }

  handleCancel = () => {
    this.props.onCancel()
  }
  validateUserAccount = ({ getFieldValue }) => ({
    validator: (_, value) => {
      const email = getFieldValue('email')
      const roles = getFieldValue('role_ids')
      const adminRole = this.props.roles.find(item => item.name === 'admin');
      const pattern = /^([A-Za-z0-9_\-.])+@(gmail.com)$/
      const isGmail = pattern.test(email)
      if(isGmail && roles.length && roles.some(r=> r === adminRole.id)){
        return Promise.reject(new Error('Gmail user can only be driver or operator !'));
      }
      return Promise.resolve()
    },
  })

  render () {
  const { user, modifyLoading, actionType, roles } = this.props
  const title = actionType === 'edit' ? 'Modify user' : 'Add user'
    const emailFormProps = {}
    const roleFormProps = {name: 'role_ids',rules: [{required: true, message: 'Please select a role'}]}
      emailFormProps.name = 'email'
      emailFormProps.rules = [
        {
          // pattern: /^([A-Za-z0-9_\-.])+@(grab.com|grabtaxi.com)$/,
          pattern: /^([A-Za-z0-9_\-.])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
          message: 'The input is not valid E-mail!'
        },
        {
          required: true,
          message: 'Please input your E-mail!'
        },
      ]
      roleFormProps.name ='role_ids'
      roleFormProps.dependencies = ['email']
      roleFormProps.rules.push(this.validateUserAccount)

    return (
      <Modal
        onOk={this.handleSubmit}
        onCancel={this.handleCancel}
        visible
        width={400}
        okText='confirm'
        confirmLoading={modifyLoading}
        title={title}
      >
        <Form ref={this.formRef} onFinish={this.handleFinish} initialValues={user}>
          <Form.Item label='Email' {...emailFormProps}>
            {actionType === 'edit' ? user.email : <Input onChange={this.handleEmailChange} />}
          </Form.Item>
          <Form.Item
            label='Roles'
            {...roleFormProps}
          >
            <Select mode='multiple' onChange={this.handleRoleChange} >
              {roles.map(d => (
                <Select.Option value={d.id} key={d.id}>
                  {d.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    )
  }
}
export default EditUserModal
